<template>
  <b-dropdown id="langddm" class="translate_wrapper ml-2 h-32" :variant="variant ? variant : 'dark'" size="md"
    toggle-class="language-button">
    <template slot="button-content">
      <i class="icon-world"></i>
      <span class="name f-14">{{ langText }}</span>
      <i class="ml-1 fa fa-sort-down f-12" style="position: relative;top: -2px;"></i>
    </template>
    <b-dropdown-item class="f-black f-14" v-for="(l, index) in localeOptions" :key="index" @click="changeLocale(l)"
      v-bind:t_label="'EMPBE_Header_Lang_' + l.langid">
      <!-- <i class="flag-icon" :class="l.icon"></i> -->
      {{ l.name }}</b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { mapActions } from 'vuex';
import { localeOptions } from '../../constants/config';
import { webResourcesService } from "../../../src/_services"


export default {
  props: ['variant'],
  name: 'Language',
  data() {
    return {
      localeOptions,
      langText: localStorage.getItem('currentLanguageName') || '简体中文'
    };
  },
  watch: {
    '$i18n.locale'(to, from) {
      if (from !== to) {
        this.$router.go(this.$route.path);
      }
    },
  },
  mounted() {
    var currentLanguageName = localeOptions.filter(x => x.name === (this.langText))[0];
    // this.GetWebResources(currentLanguageName);
  },
  created() {
    var currentLanguageName = localeOptions.filter(x => x.name === (this.langText))[0];
    // this.GetWebResources(currentLanguageName);
  },
  methods: {
    ...mapActions(['setLang']),
    changeLocale(locale) {
      var currentLanguageName = locale;
      this.setLang(locale);
      //this.GetWebResources(currentLanguageName);
    },
    GetWebResources(currentLanguageName) {
      var that = this;
      var isrefresh = this.$route.query.isrefresh === 'true' ? true : false;
      webResourcesService.GetWebResourcesValue_byPrefix(currentLanguageName.langid, isrefresh)
        .then(
          data => {
            that.$i18n.mergeLocaleMessage(currentLanguageName.id, JSON.parse(data))
          }
        )
    }
  },
};
</script>
